<template>
  <div class="account-note-display">
    <p v-if="note.AdminResolved">
      <strong>Resolved by:</strong>
      <router-link :to="{ path: '/membership/members/' + note.AdminResolved.uuid }">
        {{ note.AdminResolved.dropdownLabel }}
      </router-link>
    </p>
    <p><span class="fa mr-1" :class="typeIcon"></span> {{ note.subject }}</p>
    <p class="text-dark"><span class="fa fa-clock mr-1"></span> {{ note.dateLogged | date_format }}</p>
    <p v-if="note.AdminResponsible">
      <span class="fa fa-user-circle mr-1"></span>
      <strong>Admin: </strong>
      <router-link :to="{ path: '/membership/members/' + note.AdminResponsible.uuid }">
        {{ note.AdminResponsible.dropdownLabel }}
      </router-link>
    </p>
    <p v-if="note.Car">
      <span class="fa fa-car mr-1"></span>
      <router-link :to="{ path: '/fleet/vehicles/' + note.Car.uuid }">
        {{ note.Car.dropdownLabel }}
      </router-link>
    </p>
    <p v-if="note.Reservation">
      <span class="fa fa-calendar-alt mr-1"></span>
      <router-link :to="{ path: '/fleet/reservations/' + note.Reservation.uuid }">
        Reservation #{{ note.Reservation.reservationId }}
      </router-link>
    </p>
    <p v-if="note.Account">
      <span class="fa fa-user mr-1"></span>
      <router-link :to="{ path: '/membership/members/' + note.Account.uuid }">
        {{ note.Account.dropdownLabel }}
      </router-link>
    </p>
    <template v-if="note.description">
      <strong>Description: </strong>
      <div v-html="note.description"></div>
    </template>
    <p v-if="note.AmazonImages.length > 0"><span class="fa fa-paperclip mr-1"></span> Attachments</p>
    <template v-for="(image, index) in note.AmazonImages">
      <a v-if="image.objectKey.includes('pdf')" target="_blank" :key="index"
      :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
        PDF {{ index + 1 }}
      </a>
      <a v-else target="_blank" :key="index"
      :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
        <img :src="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`" class="img-fluid img-thumbnail mb-2" />
      </a>
    </template>
    <p class="text-right">
      <button class="btn btn-success btn-sm" type="button" @click="resolveNote()" v-if="!note.resolved">
        <span class="fa fa-check"></span> Mark As Resolved
      </button>
    </p>
  </div>
</template>

<script>
import { RESOLVE_NOTE } from '@/vuex/types'
import { iconMap } from '@/util/helpers'

export default {
  name: 'AccountNoteDisplay',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      updatedNote: {}
    }
  },
  computed: {
    note () {
      return {
        Account: null,
        AdminResolved: null,
        AdminResponsible: null,
        AmazonImages: [],
        Car: null,
        Reservation: null,
        ...this.data,
        ...this.updatedNote
      }
    },
    typeIcon () {
      for (let key in iconMap.AccountNote) {
        if (this.note.subject.includes(key)) {
          return iconMap.AccountNote[key]
        }
      }
      return 'fa-sticky-note'
    }
  },
  methods: {
    async resolveNote () {
      let result = await this.$store.dispatch(RESOLVE_NOTE, this.note.uuid)
      this.updatedNote = result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccountNoteDisplay.vue